import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';

@Component({
  selector: 'app-requisito-tipo-operario',
  templateUrl: './requisito-tipo-operario.component.html',
  styleUrls: ['./requisito-tipo-operario.component.css']
})
export class RequisitoTipoOperarioComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;

  public vecTipoRequisitos = [];
  public vecAddTipo = []; public tituloModal: string; private accion: number;

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService) { }

  ngOnInit() {
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.cargarTipoRequisito();
    //this.accIngreso = localStorage.getItem('insUser') == "true" ? true : false;
    //this.accEditar = localStorage.getItem('modUser') == "true" ? true : false;
    //this.accEliminar = localStorage.getItem('delUser') == "true" ? true : false;
  }
  //FUNCION QUE CARGA TODOS LOS TIPOS DE BECAS REGISTRADOS EN EL SISTEMA
  async cargarTipoRequisito() {
    this.cargando.abrir();
    this.vecTipoRequisitos = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(3, "na", "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let i in res.becas) {
        this.vecTipoRequisitos.push({
          idTipo: res.becas[i]['intIdTipo'], nombre: res.becas[i]['strNombre'], detalle: res.becas[i]['strDescripcion'],
          estado: res.becas[i]['intEstado'] == 1 ? "Activo" : "Inactivo",
          etiqueta: res.becas[i]['intEstado'] == 1 ? "Desactivar" : "Activar"
        });
      }
    }
    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //FUNCION QUE ABRE EL MODAL PARA AGREGAR UN NUEVO TIPO DE BECA
  async modalNuevoTipo(nameMod) {
    if (localStorage.getItem('insUser') == 'true') {
      this.tituloModal = "Ingresar un tipo de beca"; this.accion = 4;
      this.borrarDatos();
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION PARA ABRIR EL MODAL QUE PERMITE EDITAR EL TIPO DE REQUISITO
  modalModTipo(nameMod, objRol) {
    if (localStorage.getItem('modUser') == 'true') {
      this.tituloModal = "Modificar el tipo de requisito"; this.accion = 5;
      this.buscarTipoRequisito(objRol);
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION QUE PERMITE AGREGAR O EDITAR UN TIPO DE BECA
  agregarTipoBeca() {
    this.srvInsert.ingresoGestionBecas(this.vecAddTipo[0]['idTipo'], this.vecAddTipo[0]['nombre'], this.vecAddTipo[0]['detalle'], this.vecAddTipo[0]['estado'],
      'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', this.accion).subscribe(res => {
        if (res.becas) {

          this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), localStorage.getItem('perfilAudita'), 'ingresoGestionBecas()', 'INGRESAR / EDITAR un tipo de requisito',
            this.accion, ' Id_Tipo_Req - ' + this.vecAddTipo[0]['idTipo'] + ' Nombre_Tipo_Req - ' + this.vecAddTipo[0]['nombre'] + ' Detalle_Tipo_Req - ' + this.vecAddTipo[0]['detalle']
            + ' Estado_Tipo_Req - ' + this.vecAddTipo[0]['estado'], 1).subscribe(res => { });

          this.alerti.success('Tipo de beca registrado correctamente');
          this.cerrarModal();
          this.reiniciarTabla();
          this.cargarTipoRequisito();
        }
        else
          this.alerti.error("No se pudo registrar la información.");
      });
  }
  //FUNCION PARA MODIFICAR EL ESTADO DE UN TIPO DE REQUISITOS
  cambiarEstado(beca) {
    if (localStorage.getItem('modUser') == 'true') {
      this.srvInsert.ingresoGestionBecas(beca['idTipo'], beca['estado'] == "Activo" ? 2 : 1, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 6).subscribe(res => {
        if (res.becas) {
          this.alerti.success('Estado editado correctamente');
          this.reiniciarTabla();
          this.cargarTipoRequisito();
        }
        else
          this.alerti.error("No actualizar el estado.");
      });
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION PARA MOSTRAR LOS DATOS DEL DETALLE DE LA BECA SELECCIONASO
  async buscarTipoRequisito(datoRol) {
    this.cargando.abrir();
    this.vecAddTipo = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(4, datoRol['idTipo'], 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecAddTipo.push({
        idTipo: res.becas[0]['intIdTipo'], nombre: res.becas[0]['strNombre'], detalle: res.becas[0]['strDescripcion'],
        estado: res.becas[0]['intEstado']
      });
    }
    else
      this.borrarDatos();
    this.cargando.cerrar();
  }
  //INSTANCIAR LAS VARIABLES 
  borrarDatos() {
    this.vecAddTipo = [];
    this.vecAddTipo.push({
      idTipo: 0, nombre: "", detalle: "", estado: 1
    });
  }
  //FUNCION QUE ACTUALIZA LOS DATOS DE LA TABLA
  reiniciarTabla() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
    });
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
}
